import { Star } from "@mui/icons-material";
import { Box, Toolbar, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { ReactElement } from "react";
import { connect } from "react-redux";
import { selectProject } from "../../../redux/selectors/editor";
import { ProjectDetails } from "../../../redux/types/firebase";
import StateLock from "../../navbar/StateLock";
import {IStateMeta} from "../../../fstn/state";

const useStyles = makeStyles((theme) => ({
    icon: {
        marginRight: theme.spacing(1)
    },
    toolbar: {
        borderBottom: 'solid 1px lightgrey',
        justifyContent: "space-between",
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        minHeight: "32px"
    },
    title: {
        flexGrow: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    header: {
        borderRadius: "6px 6px 0px 0px"
    }
}));

interface Props
{
    project: string
    onContextMenu: (event: React.MouseEvent<HTMLElement>) => void
    onToolbarClick?: (event: React.MouseEvent<HTMLDivElement>) => void
    icon?: ReactElement | null
    id: string
    projectDetails: ProjectDetails
    data: {
        initial: string
        label: string
        meta: IStateMeta
        child?: string
    }
}

function NodeHeader({ id, project, onContextMenu, onToolbarClick, icon, data, projectDetails}: Props)
{
    const classes = useStyles();
    const showLock = projectDetails.cookbook;

    return (
        <Box onContextMenu={onContextMenu} data-state={id} className={classes.header}>
            <Toolbar disableGutters className={classes.toolbar} onClick={onToolbarClick}>
                {data.initial && <Star fontSize="small" className={classes.icon} />}
                {icon}
                <Typography className={classes.title} variant="body2">{data.label}</Typography>
                {showLock && <StateLock project={project} size="medium" state={id} />}
            </Toolbar>
        </Box>
    );
}

const mapStateToProps = (store: never) => ({
    project: selectProject(store)
});
export default connect(mapStateToProps, {
})(NodeHeader);